/**
 * Atelier ERP mark — a needle threaded with a loop of thread.
 * Drawn as inline SVG so it inherits currentColor and stays crisp at any size.
 */
export function LogoMark({ size = 32, className = '' }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 32 32"
      className={className}
      role="img"
      aria-label="Atelier ERP"
    >
      <rect width="32" height="32" rx="7" fill="rgb(var(--fill-brand))" />
      <path
        d="M9 23.5 L21.5 8.5"
        stroke="white"
        strokeWidth="2.2"
        strokeLinecap="round"
      />
      <circle cx="21.8" cy="8.2" r="2.6" fill="none" stroke="white" strokeWidth="1.8" />
      <path
        d="M9.5 22.8 C6 20 7.5 16.5 11 17.5 C14 18.4 13 22 9.8 21.4"
        fill="none"
        className="stroke-accent-500"
        strokeWidth="1.9"
        strokeLinecap="round"
      />
    </svg>
  );
}

/** Mark + wordmark. `compact` drops the tagline. */
export default function Logo({ size = 32, compact = false, className = '' }) {
  return (
    <span className={`flex items-center gap-2.5 ${className}`}>
      <LogoMark size={size} className="shrink-0" />
      <span className="min-w-0 leading-none">
        <span className="block truncate text-[15px] font-bold tracking-tight text-content">
          Atelier<span className="text-brand-600">ERP</span>
        </span>
        {!compact && (
          <span className="mt-0.5 block truncate text-2xs font-medium uppercase tracking-[0.14em] text-content-subtle">
            Bespoke Tailoring
          </span>
        )}
      </span>
    </span>
  );
}
